import React from 'react';

import searchIcon from '../../../assets/searchIcon.png'
import formIcon from '../../../assets/formIcon.png'
import reportIcon from '../../../assets/reportIcon.png'

const Features = () => {
  return (
    <div className="mt-16 grid md:grid-cols-3 gap-8">
      <div className="text-center">
        <div className="bg-primary-100 p-3 rounded-full w-12 h-12 mx-auto mb-4 flex items-center justify-center">
          <img
            src={searchIcon}
            alt="Search icon"
          />
        </div>
        
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Find Your Restaurant</h3>
        <p className="text-gray-600">Search and select your restaurant from Google Places</p>
      </div>
      
      <div className="text-center">
        <div className="bg-green-100 p-3 rounded-full w-12 h-12 mx-auto mb-4 flex items-center justify-center">
          <img
            src={formIcon}
            alt="Form icon"
          />
        </div>
        
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Fill Out Form</h3>
        <p className="text-gray-600">Provide your details to receive the report</p>
      </div>
      
      <div className="text-center">
        <div className="bg-purple-100 p-3 rounded-full w-12 h-12 mx-auto mb-4 flex items-center justify-center">
          <img
            src={reportIcon}
            alt="report icon"
          />
        </div>
        
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Get Your Report</h3>
        <p className="text-gray-600">Receive detailed reputation analysis via email</p>
      </div>
    </div>
  );
};

export default Features;
